<template>
    <div class="stepBox">
    	<ul class="process">
    		<li v-for="(item,index) in serviceLst" :style="{width:percentage}" :class="{active:index <= serviceIndex}">
    			<div></div>
          <template v-if="!isStartRescue">
            <p class="txt" :class="{active:index <= serviceIndex - 1}">{{languageIndex == 0?item.dict.name:item.dict.nameEn}}</p>
            <p class="line" :class="{active:index <= serviceIndex - 2}"  v-if="caseState != 110"></p>
            <p class="line" :class="{active:index <= serviceIndex - 1}"  v-else></p>            
          </template>
          <template v-else>
            <p class="txt" :class="{active:index <= serviceIndex}">{{languageIndex == 0?item.dict.name:item.dict.nameEn}}</p>
            <p class="line" :class="{active:index <= serviceIndex - 1}"></p>        
          </template>
    		</li>
    		<template v-if="caseState != 110">
    		  <li :style="{width:percentage}" :class="{active:serviceLst.length == serviceIndex - 1}">
    		    <div></div>
    		    <p class="txt" :class="{active:serviceLst.length == serviceIndex - 1}">{{languageIndex == 0?'完成':'Complete'}}</p>
    		  </li>
    		</template>
    		<template v-else>
    		  <li :style="{width:percentage}" :class="{active:serviceLst.length == serviceIndex}">
    		    <div></div>
    		    <p class="txt" :class="{active:serviceLst.length == serviceIndex}">{{languageIndex == 0?'完成':'Complete'}}</p>
    		  </li>
    		</template>
    	</ul>
    </div>
</template>

<script>
	export default{
		data(){
			return{
				percentage:''
			}
		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		mounted(){
			this.percentage=100/(this.serviceLst.length + 1) + '%'
		},
		props:[
			'serviceLst',
			'serviceIndex',
      'caseState',
      'isStartRescue'
		],
		watch:{
			serviceLst(){
				this.percentage=100/(this.serviceLst.length + 1) + '%'
			}
		}
	}
</script>

<style scoped="scoped">
.stepBox {padding: 20px 0;width:100%;margin: 0 auto;}
.stepBox .process{overflow: hidden;width: 100%;margin: 0 auto;}
.stepBox .process li{float: left;position: relative;}
.stepBox .process li >div{width: 20px;height: 20px;line-height: 20px;text-align: center;border-radius: 50%;background-color: #f3f3f3;color: #666;margin-right: 293px;margin: 0 auto;position: relative;z-index: 1;}
.stepBox .process li >p.txt{text-align: center;margin-top: 10px;color: #999;}
.stepBox .process li >p.active{color: #333;}
.stepBox .process li .line{position: absolute;height: 4px;background-color: #f3f3f3;width: 293px;top: 8px;left: 50%;width: 100%;z-index: 0;}
.stepBox .process .active div{background-color: #00abf9; color: white;}
.stepBox .process li .line.active{background-color: #00abf9;}
</style>



// WEBPACK FOOTER //
// src/components/process/index1.vue